export type Lang = "zh" | "en";

export interface LocaleCopy {
  title: string;
  description: string;
  brand: string;
  navHome: string;
  navServices: string;
  navPolicy: string;
  kicker: string;
  heroTitleHtml: string;
  lead: string;
  scrollHint: string;
  servicesTitle: string;
  servicesLead: string;
  services: ReadonlyArray<{ title: string; body: string }>;
  policyTitle: string;
  policyLead: string;
  policy: ReadonlyArray<{
    title: string;
    html: string;
  }>;
  footerStatus: string;
  skipToContent: string;
  langAria: string;
  themeAria: string;
  notFoundTitle: string;
  notFoundBody: string;
  notFoundBack: string;
}

export const COPY: Record<Lang, LocaleCopy> = {
  zh: {
    title: "泊杭科技 - Boorhub Technology",
    description:
      "泊杭科技是一家专注于先进数据科学、高级信息分析与机器学习、大数据安全以及相关技术的研究型公司，我们致力于成为业内具有影响力的专业解决方案提供商。",
    brand: "Boorhub",
    navHome: "首页",
    navServices: "业务",
    navPolicy: "隐私",
    kicker: "Boorhub Technology",
    heroTitleHtml: 'Boorhub <span>泊杭科技</span>',
    lead: "专注先进数据科学、高级信息分析与机器学习、大数据安全以及相关技术，致力于成为具影响力的专业解决方案提供商。",
    scrollHint: "向下滚动",
    servicesTitle: "我们的业务",
    servicesLead: "全链能力，覆盖从洞察到交付的每一个环节。",
    services: [
      {
        title: "全周期开发",
        body: "全链全生命周期开发服务涵盖开发流程中的各个阶段，包括：需求分析、设计、编码、测试、部署以及实施后的支持",
      },
      {
        title: "解决方案",
        body: "我们提供金融、互联网、高科技、电信、新零售、电商等覆盖全行业的解决方案",
      },
      {
        title: "信息咨询",
        body: "我们可在全球范围内为客户提供专业的咨询服务，帮助企业聚焦商业变革中的关键问题，从市场洞察、发掘问题到解决方案开发，提供全链全栈的咨询服务，有效提升企业效率",
      },
      {
        title: "产品工程",
        body: "从产品设计、产品开发到后期的质量测试与保证，产品工程化建设之中的每一个环节都要求软件服务提供商具有卓越的服务能力，为客户提供性能稳定、体验优秀的产品",
      },
      {
        title: "测试服务",
        body: "我们拥有成熟专业的测试方法论和先进完善的测试工具，能够提供全生命周期的测试服务，满足客户对软硬件测试的多样化需求",
      },
      {
        title: "业务外包",
        body: "我们的产品团队在业务流程外包方面有着丰富的服务经验，在业务分析、流程设计、系统开发、构筑业务对应体制、培训以及业务改善等方面都有大量的成功实践，可以为客户提供灵活、安全、高品质的服务",
      },
    ],
    policyTitle: "隐私政策",
    policyLead: "透明、开放，说明我们如何收集与保护信息。",
    policy: [
      {
        title: "概览",
        html: "您的隐私是 泊杭科技（即“我们”）在提供服务的过程中要考虑的重要因素。我们致力于做到透明和开放。本隐私权政策对我们如何收集您的信息以及如何处理这些收集到的信息进行详细说明。",
      },
      {
        title: "您提交的数据",
        html: `<p>在使用我们提供的服务过程中，我们需要您主动提交下列信息，以完成身份验证或支付服务费用等作用。</p>
<ul>
<li>我们向您征集账号名称，账号密码。数据会被加密后存储，将被用于您的身份识别。</li>
<li>我们向您征集您的邮箱地址，用于找回密码，并发送服务相关的信息等。</li>
<li>当您订阅各类通知，新闻邮件时，我们会向您的邮箱地址发送对应的邮件。</li>
<li>在购买服务时，我们向您征集您的个人支付标识，这是由您所使用的支付平台提供的数据，将被用于标记您的支付身份。</li>
</ul>`,
      },
      {
        title: "服务运行过程中，系统自动收集的信息",
        html: `<p>为了确保服务健康有序地运行，并提供某些重要功能，我们会在您使用服务的过程中收集用量数据。这些数据主要被用于三个方面：</p>
<ul>
<li>服务优化及维护：当您在使用我们的服务出现异常时，系统会自动收集异常信息，并提供给我们的技术人员，以便对其进行调整，保障服务正常运行。</li>
<li>用量统计：统计您的服务使用量。</li>
<li>安全检查：在判断您是否违反服务条款的时侯，这些数据是我们作出判断的依据之一。</li>
</ul>`,
      },
      {
        title: "隐私数据保护",
        html: "我们采用业界通用标准加密存储您的隐私数据，并且不会向任何第三方透露您的隐私数据。",
      },
    ],
    footerStatus: "status",
    skipToContent: "跳到正文",
    langAria: "切换语言",
    themeAria: "切换明暗主题",
    notFoundTitle: "404",
    notFoundBody: "此页不存在。",
    notFoundBack: "← 返回首页",
  },
  en: {
    title: "Boorhub Technology",
    description:
      "Boorhub Technology is a research-driven firm focused on advanced data science, analytics and machine learning, big-data security, and related technologies — building influential professional solutions.",
    brand: "Boorhub",
    navHome: "Home",
    navServices: "Services",
    navPolicy: "Privacy",
    kicker: "Boorhub Technology",
    heroTitleHtml: "Boorhub <span>Technology</span>",
    lead: "Advanced data science, information analytics & machine learning, big-data security, and related research — professional solutions with lasting impact.",
    scrollHint: "Scroll",
    servicesTitle: "What we do",
    servicesLead: "End-to-end capability from insight to delivery.",
    services: [
      {
        title: "Full-cycle development",
        body: "End-to-end lifecycle services across every stage of delivery: requirements, design, coding, testing, deployment, and post-implementation support.",
      },
      {
        title: "Industry solutions",
        body: "Solutions spanning finance, internet, high-tech, telecom, new retail, e-commerce, and more.",
      },
      {
        title: "Consulting",
        body: "Global consulting that helps enterprises focus on the hard problems of change — from market insight and problem discovery to solution design — improving efficiency across the stack.",
      },
      {
        title: "Product engineering",
        body: "From product design and development through quality assurance, every stage of product engineering demands excellence — stable performance and exceptional experience for your users.",
      },
      {
        title: "Testing",
        body: "Mature methodologies and modern tooling for full-lifecycle software and hardware testing, tailored to diverse quality needs.",
      },
      {
        title: "Business process outsourcing",
        body: "Deep BPO experience in analysis, process design, system development, operating models, training, and continuous improvement — flexible, secure, high-quality delivery.",
      },
    ],
    policyTitle: "Privacy policy",
    policyLead: "Transparent practices for how we collect and protect information.",
    policy: [
      {
        title: "Overview",
        html: "Your privacy is an important factor for Boorhub Technology (“we”, “us”) when providing services. We aim to be transparent and open. This policy explains how we collect and handle your information.",
      },
      {
        title: "Data you submit",
        html: `<p>When you use our services, we may need you to submit the following information to complete identity verification or pay for services.</p>
<ul>
<li>Account name and password — stored encrypted and used for identity verification.</li>
<li>Email address — for password recovery and service-related notices.</li>
<li>When you subscribe to notifications or newsletters, we send corresponding messages to your email.</li>
<li>When purchasing services, a personal payment identifier from your payment platform marks your payment identity.</li>
</ul>`,
      },
      {
        title: "Information collected automatically",
        html: `<p>To keep services healthy and to provide essential features, we collect usage data while you use the service. This data is mainly used in three ways:</p>
<ul>
<li>Service optimization and maintenance: diagnostic information may be collected when anomalies occur so engineers can restore normal operation.</li>
<li>Usage statistics: measuring how services are used.</li>
<li>Security checks: usage data may inform whether activity violates our terms of service.</li>
</ul>`,
      },
      {
        title: "Protecting private data",
        html: "We store private data with industry-standard encryption and do not disclose it to any third party.",
      },
    ],
    footerStatus: "status",
    skipToContent: "Skip to content",
    langAria: "Switch language",
    themeAria: "Toggle color theme",
    notFoundTitle: "404",
    notFoundBody: "This page does not exist.",
    notFoundBack: "← Home",
  },
};

export const STORAGE_LANG = "boorhub.lang";
export const STORAGE_THEME = "boorhub.theme";
